import classNames from 'classnames/bind'
import style from './BasicPopup.module.scss'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { DataModalProps, DialogTitleProps } from './BasicPopup.model'

const cx = classNames.bind(style)

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  // '& .MuiDialog-paper': {
  // 	width: '500px !important'
  // },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

export const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle
      sx={{ m: 0, pt: 2, px: 2, pb: 1 }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          id='btn-close'
          tabIndex={-1}
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon sx={{ height: '20px', width: '20px' }} />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

export const BasicPopup = (props: DataModalProps) => {
  const {
    title,
    maxWidth = 'md',
    fullWidth = false,
    open,
    onClose,
    children,
    ...otherProps
  } = props
  const isDark = useAppSelector(isDarkTheme)

  return (
    <div className={cx('wrapper')}>
      <BootstrapDialog
        {...otherProps}
        maxWidth={maxWidth}
        fullWidth={fullWidth}
        onClose={(e, reason) => (reason !== 'backdropClick' ? onClose() : {})}
        aria-labelledby='customized-dialog-title'
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            background: isDark ? 'var(--dark-gray-background)' : '',
            color: isDark ? 'white' : 'var(--dark)',
            width: props.width,
            minWidth: props.minWidth
          }
        }}
      >
        <BootstrapDialogTitle
          id='customized-dialog-title'
          onClose={onClose}
        >
          <div style={{ fontSize: 'var(--fs-title-md' }}>{title}</div>
        </BootstrapDialogTitle>
        <DialogContent sx={{ py: '0 !important' }}>
          <div className={cx('content')}>{children}</div>
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
